import GenericAvailableForTransfer from './availableForTransfers';

export default GenericAvailableForTransfer;
